import React from 'react';
import { PowerOff } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { getPageMeta } from '../../data/navigation';
import Button from './Button';
import { t } from '../../i18n';

// Se muestra cuando se intenta abrir una página cuyo módulo está apagado en
// Administración → Configuración de módulos.
const ModuleDisabled = ({ pageId }) => {
  const { setActivePage } = useAppContext();
  const meta = getPageMeta(pageId);
  return (
    <div className="bg-white border border-neutral-200 rounded p-6 max-w-xl">
      <div className="flex items-start gap-3">
        <PowerOff className="w-5 h-5 text-neutral-400 mt-0.5" />
        <div>
          <h1 className="text-base font-semibold text-neutral-900">{t('Módulo desactivado')}</h1>
          <p className="text-sm text-neutral-500 mt-1">
            {t('«{0}» está desactivado en la configuración de módulos. Un Administrador o Director de Proyectos puede activarlo en Administración.', t(meta.moduleLabel || meta.pageLabel))}
          </p>
          <Button className="mt-4" variant="primary" size="sm" onClick={() => setActivePage('dashboard')}>{t('Ir al Dashboard')}</Button>
        </div>
      </div>
    </div>
  );
};

export default ModuleDisabled;
